function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import AWS from 'aws-sdk';
const bucketName = process.env.REACT_APP_AWS_BUCKET;
const Region = process.env.REACT_APP_AWS_REGION;
const accesKeyId = process.env.REACT_APP_ACCESSKEY_ID;
const secretAccesKeyId = process.env.REACT_APP_SECRET_ACCESS_KEY;
const awsUrl = process.env.REACT_APP_AWS_URL;
AWS.config.update({
  accessKeyId: accesKeyId,
  secretAccessKey: secretAccesKeyId
});
const myBucket = new AWS.S3({
  params: {
    Bucket: bucketName
  },
  region: Region
});
export const uploadFileS3 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (files, filename, typeFile, continueUpload) {
    const params = {
      ACL: 'public-read',
      Body: files,
      Bucket: "".concat(bucketName, "/").concat(typeFile),
      Key: filename.split(' ').join('')
    };
    yield myBucket.putObject(params, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (err) {
        if (err) yield continueUpload(new Error(err));else yield continueUpload("".concat(awsUrl, "/").concat(typeFile, "/").concat(filename.split(' ').join('')));
      });

      return function (_x5) {
        return _ref2.apply(this, arguments);
      };
    }());
  });

  return function uploadFileS3(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();